import { SvgIcon, SvgIconProps } from '@mui/material'

const ArrowUploadSetup = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#a)">
        <mask
          id="b"
          width="16"
          height="16"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
        >
          <path fill="#333" d="M16 0H0v16h16V0Z" />
        </mask>
        <g fill="#004744" fillRule="evenodd" clipRule="evenodd" mask="url(#b)">
          <path d="M14 7.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8.003a.5.5 0 1 1 1 0V13.5h11V8a.5.5 0 0 1 .5-.5ZM7.646 1.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8 2.707 5.354 5.354a.5.5 0 1 1-.708-.708l3-3Z" />
          <path d="M7.997 1.5a.5.5 0 0 1 .5.5v8.667a.5.5 0 0 1-1 0V2a.5.5 0 0 1 .5-.5Z" />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default ArrowUploadSetup
